import { render } from "./guestRewardsBanner.vue?vue&type=template&id=2892762a&scoped=true&ts=true"
import script from "./guestRewardsBanner.vue?vue&type=script&lang=ts"
export * from "./guestRewardsBanner.vue?vue&type=script&lang=ts"

import "./guestRewardsBanner.vue?vue&type=style&index=0&id=2892762a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2892762a"]])

export default __exports__